import { AgGridService } from "@topline/services/agGridService";
import { MarketEditService } from "../services/marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component("marketFinishValidation", {
        template: require('./marketFinishValidationComponent.html'),
        bindings: {
            resolve: "<",
            close: "&",
            dismiss: "&"
        },
        controller: [
            AgGridService.componentName,
            angularServicesNames.$translate,
            MarketEditService.componentName,
            function(
                this: $TSFixMe,
                agGridService: AgGridService,
                $translate: ng.translate.ITranslateService,
                marketEditService: MarketEditService
            ) {
                var $ctrl = this;

                $ctrl.$onInit = function () {
                    $ctrl.markets = $ctrl.resolve.markets;
                    if ($ctrl.resolve.validationResult.multipleNamesToFinishViolation.length > 0) {
                        $ctrl.isMultipleNamesViolation = true;
                        $ctrl.isNameAlreadFinishViolation = false;
                        $ctrl.isBudgetYearIsNotDefined = false;
                        $ctrl.isAnyMarketNotMetRequirements = false;
                        $ctrl.multipleNamesGridOptions = createMultipleNamesToFinishViolationGrid();
                    } else if ($ctrl.resolve.validationResult.marketWithoutBudgetYear.length > 0) {
                        $ctrl.isMultipleNamesViolation = false;
                        $ctrl.isNameAlreadFinishViolation = false;
                        $ctrl.isBudgetYearIsNotDefined = true;
                        $ctrl.isAnyMarketNotMetRequirements = false;
                        $ctrl.noBudgetYearGridOptions = createBudgetYearIsNotDefinedGrid();
                    } else if ($ctrl.resolve.validationResult.marketNotMetRequirements.length > 0) {
                        $ctrl.isMultipleNamesViolation = false;
                        $ctrl.isNameAlreadFinishViolation = false;
                        $ctrl.isBudgetYearIsNotDefined = false;
                        $ctrl.isAnyMarketNotMetRequirements = true;
                        $ctrl.notMetRequirementsGridOptions = createMarketNotMetRequirementsGrid();
                    } else {
                        $ctrl.isMultipleNamesViolation = false;
                        $ctrl.isNameAlreadFinishViolation = true;
                        $ctrl.isBudgetYearIsNotDefined = false;
                        $ctrl.isAnyMarketNotMetRequirements = false;
                        $ctrl.alreadyFinishedGridOptions = createMarketWithSameNamesAlreadyFinishGrid();
                    }
                };

                $ctrl.toggleMarketFinished = (market: $TSFixMe) => {
                    marketEditService.toggleMarketFinished(market.id, false).then(
                        () => (market.isFinished = false)
                    );
                };

                $ctrl.ok = () => $ctrl.close();

                $ctrl.cancel = () =>
                    $ctrl.dismiss({
                        $value: "cancel"
                    });

                function createMultipleNamesToFinishViolationGrid() {
                    return {
                        columnDefs: [
                            {
                                field: "name",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.NAME"),
                                minWidth: 450,
                                cellStyle: { textAlign: "left" }
                            },
                            {
                                field: "budgetYear",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.BUDGET_YEAR")
                            },
                            {
                                headerValueGetter: () => $translate.instant("MARKET.VERSION"),
                                field: "versions"
                            }
                        ],
                        domLayout: "autoHeight",
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        enableFilter: false,
                        animateRows: true,
                        localeTextFunc: agGridService.transalteFunc,
                        suppressHorizontalScroll: true,
                        onGridReady: (config: $TSFixMe) => {
                            $ctrl.gridApi = config.api;
                            config.api.sizeColumnsToFit();
                            config.api.setRowData($ctrl.resolve.validationResult.multipleNamesToFinishViolation);
                        },
                        onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                    };
                }

                function createMarketWithSameNamesAlreadyFinishGrid() {
                    return {
                        columnDefs: [
                            {
                                field: "name",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.NAME"),
                                minWidth: 450,
                                cellStyle: { textAlign: "left" }
                            },
                            {
                                field: "budgetYear",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.BUDGET_YEAR")
                            },
                            {
                                headerValueGetter: () => $translate.instant("MARKET.VERSION"),
                                field: "version"
                            },
                            {
                                headerValueGetter: () => $translate.instant("ACTIONS"),
                                cellRenderer: (params: $TSFixMe) => params.data
                                    ? '<div class="ui-grid-cell-contents"><a href="#" ng-show="data.isFinished" ng-click="$ctrl.toggleMarketFinished(data)"><i class="fas fa-lock-open"></i></a></div>'
                                    : null
                            }
                        ],
                        domLayout: "autoHeight",
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        enableFilter: false,
                        animateRows: true,
                        localeTextFunc: agGridService.transalteFunc,
                        suppressHorizontalScroll: true,
                        onGridReady: (config: $TSFixMe) => {
                            $ctrl.gridApi = config.api;
                            config.api.sizeColumnsToFit();
                            for (const market of $ctrl.resolve.validationResult.marketWithSameNamesAlreadyFinish) {
                                market.isFinished = true;
                            }
                            config.api.setRowData($ctrl.resolve.validationResult.marketWithSameNamesAlreadyFinish);
                        },
                        onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                    };
                }

                function createBudgetYearIsNotDefinedGrid() {
                    return {
                        columnDefs: [
                            {
                                field: "name",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.NAME"),
                                minWidth: 450,
                                cellStyle: { textAlign: "left" }
                            },
                            {
                                headerValueGetter: () => $translate.instant("MARKET.VERSION"),
                                field: "version"
                            }
                        ],
                        domLayout: "autoHeight",
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        enableFilter: false,
                        animateRows: true,
                        localeTextFunc: agGridService.transalteFunc,
                        suppressHorizontalScroll: true,
                        onGridReady: (config: $TSFixMe) => {
                            $ctrl.gridApi = config.api;
                            config.api.sizeColumnsToFit();
                            config.api.setRowData($ctrl.resolve.validationResult.marketWithoutBudgetYear);
                        },
                        onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                    };
                }

                function createMarketNotMetRequirementsGrid() {
                    return {
                        columnDefs: [
                            {
                                field: "name",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.NAME"),
                                minWidth: 450,
                                cellStyle: { textAlign: "left" }
                            },
                            {
                                field: "budgetYear",
                                headerValueGetter: () => $translate.instant("MARKET.LIST_GRID.BUDGET_YEAR")
                            },
                            {
                                headerValueGetter: () => $translate.instant("MARKET.VERSION"),
                                field: "version"
                            }
                        ],
                        domLayout: "autoHeight",
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        enableFilter: false,
                        animateRows: true,
                        localeTextFunc: agGridService.transalteFunc,
                        suppressHorizontalScroll: true,
                        onGridReady: (config: $TSFixMe) => {
                            $ctrl.gridApi = config.api;
                            config.api.sizeColumnsToFit();
                            config.api.setRowData($ctrl.resolve.validationResult.marketNotMetRequirements);
                        },
                        onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                    };
                }
            }
        ]
    });

})(angular.module("topline.modules"));
